import { FilterFormData } from '../stores/ui/uiStore';
import { TokenState } from '../stores/data/types';

/**
 * 범위 필터 조건을 검사하는 함수
 */
const checkRangeFilter = (value: number, filter: { min?: number; max?: number }): boolean => {
  if (filter?.min !== undefined && value < filter?.min) return false;
  if (filter?.max !== undefined && value > filter?.max) return false;
  return true;
};

/**
 * 토큰 데이터를 필터링하는 함수
 */
export const filterTokenData = (tokens: TokenState[], filters: FilterFormData | null): TokenState[] => {
  if (!filters) return tokens;

  return tokens.filter(token => {
    const { statistics, devCluster, ranking } = token;
    if (!statistics) return false;

    // 필터 조건들을 배열로 정의
    const filterConditions = [
      { value: statistics.currentAfCnt, filter: filters.currentAfCnt },
      { value: statistics.athAfCnt, filter: filters.athAfCnt },
      { value: statistics.atlMc, filter: filters.atlMc },
      { value: statistics.athMc, filter: filters.athMc },
      { value: (token.priceTracker?.mcap ?? statistics.lastFlow.mc), filter: filters.mc },
      { value: statistics.currentTokenAmountInDecimals, filter: filters.currentTokenAmountInDecimals },
      { value: statistics.athTokenAmountInDecimals, filter: filters.athTokenAmountInDecimals },
      { value: statistics.totalUsedUsd, filter: filters.totalUsedUsd },
      { value: devCluster.buyerCount, filter: filters.devClusterCnt },
      { value: ranking.cumulativeConvictionAtSameTimeRank, filter: filters.cumulativeConvictionAtSameTimeRank }
    ];

    // 모든 필터 조건을 검사
    return filterConditions.every(({ value, filter }) => checkRangeFilter(value, filter));
  });
};

/**
 * 시간 범위로 토큰 데이터를 필터링하는 함수
 */
export const filterByTime = (tokens: TokenState[], timeFilter: string, customTimeMinutes?: { min?: number; max?: number }): TokenState[] => {
  const hasCustomRange = customTimeMinutes && (customTimeMinutes.min !== undefined || customTimeMinutes.max !== undefined);
  if (!hasCustomRange) return tokens; // 커스텀 범위가 없으면 필터링하지 않음

  const now = Date.now();
  
  return tokens.filter(token => {
    const firstFlowTime = token.statistics.firstFlowTimestamp.getTime();
    const elapsedMinutes = (now - firstFlowTime) / (60 * 1000); // 경과 시간을 분으로 변환

    // 커스텀 범위로 필터링
    if (customTimeMinutes.min !== undefined && elapsedMinutes < customTimeMinutes.min) {
      return false;
    }
    if (customTimeMinutes.max !== undefined && elapsedMinutes > customTimeMinutes.max) {
      return false;
    }
    return true;
  });
};

/**
 * Last Tx Time 시간 범위로 토큰 데이터를 필터링하는 함수
 */
export const filterByLastUpdated = (tokens: TokenState[], timeFilter: string, customTimeMinutes?: { min?: number; max?: number }): TokenState[] => {
  const hasCustomRange = customTimeMinutes && (customTimeMinutes.min !== undefined || customTimeMinutes.max !== undefined);
  if (!hasCustomRange) return tokens; // 커스텀 범위가 없으면 필터링하지 않음

  const now = Date.now();
  
  return tokens.filter(token => {
    // TokenState.lastUpdated는 밀리초 단위의 타임스탬프
    const elapsedMinutes = (now - token.lastUpdated) / (60 * 1000); // 경과 시간을 분으로 변환

    // 커스텀 범위로 필터링
    if (customTimeMinutes.min !== undefined && elapsedMinutes < customTimeMinutes.min) {
      return false;
    }
    if (customTimeMinutes.max !== undefined && elapsedMinutes > customTimeMinutes.max) {
      return false;
    }
    return true;
  });
};


